import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CommercialOwnersDialogData {
  owners: string[];
}

/**
 * Modal that lists the commercial owners of a company (Figma node 1370:61735).
 *
 * Shown when the "Commercial owner" column displays the "Multiple" label — clicking it
 * opens this dialog with the full list of owner emails. Header with title + close (X),
 * divider, and a left-aligned list of emails.
 */
@Component({
  selector: 'app-commercial-owners-dialog',
  templateUrl: './commercial-owners-dialog.component.html',
  styleUrls: ['./commercial-owners-dialog.component.scss'],
})
export class CommercialOwnersDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<CommercialOwnersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: CommercialOwnersDialogData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
